// removed by extract-text-webpack-plugin
module.exports = {"Auth":"Auth__Auth__1TInt","Form":"Auth__Form__27pML","Submit":"Auth__Submit__1Zu2m","SwitchMethod":"Auth__SwitchMethod__2ZQcn"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Auth/Auth.css
// module id = 185
// module chunks = 0